import { motion } from "framer-motion";

/**
 * Decorative layered document / system shapes.
 * Pure SVG, subtle, used as a side accent — never as a focal element.
 */
export function LayeredDocuments({ className = "" }) {
  return (
    <motion.svg
      viewBox="0 0 220 260"
      className={className}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      aria-hidden
    >
      <rect x="22" y="40" width="150" height="190" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.35" />
      <rect x="38" y="56" width="150" height="190" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.55" />
      <rect x="54" y="72" width="150" height="190" fill="currentColor" fillOpacity="0.04" stroke="currentColor" strokeWidth="1" />
      <line x1="74" y1="98" x2="184" y2="98" stroke="currentColor" strokeWidth="1" opacity="0.6" />
      <line x1="74" y1="118" x2="170" y2="118" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <line x1="74" y1="138" x2="160" y2="138" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <line x1="74" y1="158" x2="184" y2="158" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <line x1="74" y1="178" x2="148" y2="178" stroke="currentColor" strokeWidth="1" opacity="0.4" />
      <circle cx="184" cy="98" r="3" fill="#D9261C" />
    </motion.svg>
  );
}

/**
 * Connected node network — small abstract diagram suggesting linked systems.
 */
export function NodeNetwork({ className = "" }) {
  return (
    <motion.svg
      viewBox="0 0 240 200"
      className={className}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1.2 }}
      aria-hidden
    >
      {/* Edges */}
      <g stroke="currentColor" strokeWidth="1" opacity="0.45">
        <line x1="40" y1="50" x2="120" y2="100" />
        <line x1="120" y1="100" x2="200" y2="40" />
        <line x1="120" y1="100" x2="200" y2="160" />
        <line x1="120" y1="100" x2="60" y2="160" />
        <line x1="40" y1="50" x2="200" y2="40" />
        <line x1="60" y1="160" x2="200" y2="160" />
      </g>
      {/* Nodes */}
      <g>
        {[
          [40, 50],
          [200, 40],
          [200, 160],
          [60, 160],
        ].map(([x, y], i) => (
          <circle
            key={i}
            cx={x}
            cy={y}
            r="4"
            fill="currentColor"
            opacity="0.7"
          />
        ))}
        <circle cx="120" cy="100" r="7" fill="#D9261C" />
        <circle cx="120" cy="100" r="14" fill="none" stroke="#D9261C" strokeOpacity="0.35" />
      </g>
    </motion.svg>
  );
}

/**
 * Tiny corner crosshair to mark a card edge — quietly editorial.
 */
export function CornerMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden
      fill="none"
      stroke="currentColor"
    >
      <path d="M0 6V0h6" strokeWidth="1" />
      <path d="M18 0h6v6" strokeWidth="1" />
      <path d="M24 18v6h-6" strokeWidth="1" />
      <path d="M6 24H0v-6" strokeWidth="1" />
    </svg>
  );
}

/**
 * A horizontal "movement" rule — three stacked lines that hint at flow.
 */
export function MovementRule({ className = "" }) {
  return (
    <svg viewBox="0 0 120 16" className={className} aria-hidden>
      <line x1="0" y1="3" x2="120" y2="3" stroke="currentColor" strokeOpacity="0.25" />
      <line x1="0" y1="8" x2="86" y2="8" stroke="currentColor" strokeOpacity="0.45" />
      <line x1="0" y1="13" x2="48" y2="13" stroke="#D9261C" />
    </svg>
  );
}
